/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCardDetailsRequest} from '@cash-web/protos/squareup/cash/postcard/app/GetCardDetails.pb'
import {GetCardDetailsResponse} from '@cash-web/protos/squareup/cash/postcard/app/GetCardDetails.pb'


export const getCardDetails = (request: GetCardDetailsRequest, options?: CashRequestOptions) => post<GetCardDetailsRequest, GetCardDetailsResponse>("/cash-app/postcard/get-card-details", request, {...options, rejectOnError: true })